import React, { ReactNode } from "react";
import classes from './Modal.module.css'

interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
}

export default function Modal(props: ModalType) {
  return (
    <>
      {props.isOpen && (
        <div className={classes.modal_overlay} onClick={props.toggle}>
          <div onClick={(e) => e.stopPropagation()} className={classes.modal_box}>
            {props.children}
          </div>
        </div>
      )}
    </>
  );
}
